import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { AuthGuard } from '../../core/services/auth/auth.guard';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RegulationService } from 'src/app/core/services/regulation';
import { AuthService } from './../../core/services/auth/auth.service';
import { GDPRService } from './../../core/services/rulebook/gdpr.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonService } from './../../core/services/common/common.service';
import { SessionService } from './../../core/services/auth/session.service';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ChangeDetailComponent } from '../change-detail/change-detail.component';
import { CurrentActionComponent } from './current-action/current-action.component';
import { CurrentActionCardComponent } from './current-action-card/current-action-card.component';
import { LinkedUpdatesComponent } from './linked-updates/linked-updates.component';
import { SecurityInterceptor } from 'src/app/core/intercepter/security.interceptor';
import { AnalyticsService } from './../../core/services/analytics/analytics.service';
import { RulebookDialogComponent } from './rulebook-dialog/rulebook-dialog.component';
import { AssessmentDialogComponent } from './assessment-dialog/assessment-dialog.component';
import { BulkRuleAnalyticComponent } from './bulk-rule-analytic/bulk-rule-analytic.component';
import { DistributedUIModule } from '../../views/distributed-ui-components/distributed-ui.module';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { ModalDialogComponent } from '../distributed-ui-components/modal-dialog/modal-dialog.component';
import { ChangeViewerAnalyticComponent } from './change-viewer-analytic/change-viewer-analytic.component';
import { ImpactAssessmentInfoComponent } from './impact-assessment-info/impact-assessment-info.component';
import { ChangeViewerAnalyticDialogComponent } from './change-viewer-analytic-dialog/change-viewer-analytic-dialog.component';
import { EditInfoDialogComponent } from './edit-info-dialog/edit-info-dialog.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { JsonStringToArrayPipe } from './pipe/json-string-to-array.pipe';
import { TimePickerComponent } from './time-picker/time-picker.component';
import { MinToHourPipe } from './pipe/min-to-hour.pipe';
import { StringToArrayPipe } from './pipe/string-to-array.pipe';
import { ReplaceStringPipe } from './pipe/replace-string.pipe';
import { StringToArrayParentPipe } from './pipe/string-to-array-parent.pipe';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { ImpactAssessmentTemplate3Component } from './impact-assessment-template3/impact-assessment-template3.component';
import { JsonPipe } from '@angular/common';
import { RulebookStringToArrayPipe } from './pipe/rulebook-string-to-array.pipe';
import { NewRulebooksComponent } from './new-rulebooks/new-rulebooks.component';
import { SafePipe } from './pipe/safe.pipe';
import { HtmlPipe } from './pipe/html.pipe';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputTextModule } from 'primeng/inputtext';
import { RatingModule } from 'primeng/rating';
import { RulebookSummaryComponent } from './rulebook-summary/rulebook-summary.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
//import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { NewRulebookPrimengComponent } from './new-rulebook-primeng/new-rulebook-primeng.component';
import { ImpactAssessmentTemplate4Component } from './impact-assessment-template4/impact-assessment-template4.component';
import { JsonPubstringToArrayPipe } from './pipe/json-pubstring-to-array.pipe';
import { PaginatorModule } from 'primeng/paginator';
import { OverlayPanelModule } from 'primeng/overlaypanel';
//import {PaginatorModule} from 'primeng-lts/paginator';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { HighlightPipe } from './pipe/highlight.pipe';
import { BulkUpdateRuleDialogComponent } from './bulk-update-rule-dialog/bulk-update-rule-dialog.component';
import { HasHtmlTagsPipe } from './pipe/has-html-tags.pipe';
import { CkEditorRevisionComponent } from './ck-editor-revision/ck-editor-revision.component';
import { CkEditorComponent } from './ck-editor/ck-editor.component';
import { UserService } from 'src/app/core/services/user';
import { NotepadService } from 'src/app/core/services/notepad/notepad.service';
import { ImpactAssessmentTemplate5Component } from './impact-assessment-template5/impact-assessment-template5/impact-assessment-template5.component';
import {
  LucideAngularModule,
  BadgeInfo, Clipboard,
  Languages,
  SquarePen,
  X,
  Settings,
  Info,
  Upload,
  File,
  Plus,
  Save,
  MoveLeft,
  MoveRight,
  Sparkles,
  ZoomIn,
  ZoomOut,
  BadgeX
} from 'lucide-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChangeViewerRigComponent } from './change-viewer-rig/change-viewer-rig.component';
import { PolicyMappingDescriptionComponent } from './policy-mapping-description/policy-mapping-description.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { PolicyMetaDataJsonArrayPipe } from './pipe/policy-meta-data-json-array.pipe';
import { MatDividerModule } from '@angular/material/divider';
import { SafehtmlPipe } from './pipe/safehtml.pipe';
import { RigSettingsComponent } from './rig-settings/rig-settings.component';
import { ApprovalStatusPipe } from './pipe/approval-status.pipe';
import { BreadCrumbsComponent } from './bread-crumbs/bread-crumbs.component';
import { ImpactAssessmentTemplate6Component } from './impact-assessment-template6/impact-assessment-template6.component';
import { ChangeViewerRegulatoryComponent } from './change-viewer-regulatory/change-viewer-regulatory.component';
import { MatMenuModule } from '@angular/material/menu';
import { MarkdownModule } from 'ngx-markdown';
import { AvatarModule } from 'primeng/avatar';
import { SkeletonModule } from 'primeng/skeleton';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    TooltipModule,
    ScrollingModule,
    BsDropdownModule,
    TabsModule,
    CollapseModule,
    HttpClientModule,
    DistributedUIModule,
    CdkTreeModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatInputModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTabsModule,
    MatExpansionModule,
    AngularEditorModule,
    NgSelectModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    TableModule,
    CalendarModule,
    SliderModule,
    DialogModule,
    MultiSelectModule,
    ContextMenuModule,
    DropdownModule,
    ButtonModule,
    ToastModule,
    InputTextModule,
    ProgressBarModule,
    HttpClientModule,
    FormsModule,
    RatingModule,
    VirtualScrollerModule,
    PaginatorModule,
    OverlayPanelModule,
    MatPaginatorModule,
    CKEditorModule,
    LucideAngularModule.pick({
      Languages,
      SquarePen,
      X,
      Settings,
      Info,
      Upload,
      File,
      Plus,
      Save,
      Sparkles,ZoomIn,ZoomOut, MoveLeft, MoveRight, BadgeX,BadgeInfo, Clipboard
    }),
    MatTooltipModule,
    PdfViewerModule,
    MatDividerModule,
    MatMenuModule,
    MarkdownModule,
    AvatarModule,
    SkeletonModule
  ],
  providers: [
    JsonPipe,
    AuthGuard,
    GDPRService,
    SessionService,
    AuthService,
    AnalyticsService,
    UserManagementService,
    CommonService,
    RegulationService,
    UserService,
    NotepadService,
    { provide: HTTP_INTERCEPTORS, useClass: SecurityInterceptor, multi: true },
  ],
  declarations: [
    ChangeDetailComponent,
    ProgressBarComponent,
    LinkedUpdatesComponent,
    ModalDialogComponent,
    RulebookDialogComponent,
    BulkRuleAnalyticComponent,
    ChangeViewerAnalyticComponent,
    ChangeViewerAnalyticDialogComponent,
    AssessmentDialogComponent,
    CurrentActionComponent,
    CurrentActionCardComponent,
    ImpactAssessmentInfoComponent,
    EditInfoDialogComponent,
    DateRangePickerComponent,
    JsonStringToArrayPipe,
    TimePickerComponent,
    MinToHourPipe,
    StringToArrayPipe,
    ReplaceStringPipe,
    StringToArrayParentPipe,
    ImpactAssessmentTemplate3Component,
    SafePipe,
    HtmlPipe,
    NewRulebooksComponent,
    RulebookStringToArrayPipe,
    RulebookSummaryComponent,
    NewRulebookPrimengComponent,
    ImpactAssessmentTemplate4Component,
    JsonPubstringToArrayPipe,
    HighlightPipe,
    BulkUpdateRuleDialogComponent,
    HasHtmlTagsPipe,
    CkEditorRevisionComponent,
    CkEditorComponent,
    ImpactAssessmentTemplate5Component,
    ChangeViewerRigComponent,
    PolicyMappingDescriptionComponent,
    PdfViewerComponent,
    PolicyMetaDataJsonArrayPipe,
    SafehtmlPipe,
    RigSettingsComponent,
    ApprovalStatusPipe,
    BreadCrumbsComponent,
    ImpactAssessmentTemplate6Component,
    ChangeViewerRegulatoryComponent
  ],
  exports: [
    ChangeDetailComponent,
    ProgressBarComponent,
    LinkedUpdatesComponent,
    ModalDialogComponent,
    ChangeViewerAnalyticComponent,
    CurrentActionComponent,
    CurrentActionCardComponent,
    ImpactAssessmentInfoComponent,
    DateRangePickerComponent,
    JsonStringToArrayPipe,
    StringToArrayPipe,
    StringToArrayParentPipe,
    ReplaceStringPipe,
    SafePipe,
    HtmlPipe,
    RulebookStringToArrayPipe,
    NewRulebooksComponent,
    NewRulebookPrimengComponent,
    ImpactAssessmentTemplate4Component,
    JsonPubstringToArrayPipe,
    CkEditorComponent,
    CkEditorRevisionComponent,
    HasHtmlTagsPipe,
    ImpactAssessmentTemplate5Component,
    ImpactAssessmentTemplate6Component,
    PolicyMetaDataJsonArrayPipe,
    SafehtmlPipe,
    RigSettingsComponent,
    ApprovalStatusPipe,
    MinToHourPipe,
    PdfViewerComponent,
    BreadCrumbsComponent,
  ],
  entryComponents: [
    RulebookDialogComponent,
    BulkRuleAnalyticComponent,
    ChangeViewerAnalyticDialogComponent,
    AssessmentDialogComponent,
    CurrentActionComponent,
    CurrentActionCardComponent,
    ImpactAssessmentInfoComponent,
    ImpactAssessmentTemplate4Component,
    BulkUpdateRuleDialogComponent,
    ImpactAssessmentTemplate5Component,
    ImpactAssessmentTemplate6Component,
    RigSettingsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedUIModule {}
